export const ACCOUNT_API_ERRORS = {
  customer: {
    email_already_exists: 'account.email-already-exists',
    no_such_email: 'account.no-such-email',
    already_active: 'account.already-active',
    activation_token_invalid: 'account.activation-token-invalid',
    activation_token_expired: 'account.activation-token-expired',
    password_reset_token_invalid: 'account.password-reset-token-invalid',
    password_reset_token_expired: 'account.password-reset-token-expired',
    password_reset_same_password: 'account.password-reset-same-password',
    invalid_credentials: 'account.invalid-credentials',
    invalid_password: 'account.invalid-password',
    not_active: 'account.not-active',
    locked: 'account.locked',
    unknown: 'account.unknown',
    invalid_recaptcha_response: 'account.invalid-recaptcha-response'
  },
  reservation: {
    not_found_for_claim: 'reservation.not-found-for-claim',
    already_claimed: 'reservation.already-claimed',
    already_claimed_by_other: 'reservation.already-claimed-by-other',
    already_assigned: 'reservation.already-assigned',
    already_assigned_to_other: 'reservation.already-assigned-to-other'
  },
  check_in: {
    identity_verification_failed: 'check-in.identity-verification-failed',
    confirmation_failed: 'check-in.confirmation-failed',
    invalid_passport_file: 'check-in.invalid-passport-file',
    invalid_reservation_id: 'check-in.invalid-reservation-id',
    unsupported_passport_file: 'check-in.unsupported-passport-file',
    invalid_card_holder: 'check-in.invalid-card-holder',
    already_checked_in: 'check-in.already-checked-in',
    unknown: 'check-in.unknown'
  },
  validation: {
    invalid_email: 'validation.invalid-email',
    invalid_password: 'validation.invalid-password'
  },
  generic: {
    unknown: 'account.unknown',
    payload_too_large: 'generic.payload-too-large',
    internal_server_error: 'generic.internal-server-error'
  }
};
